import { ICellRendererParams } from 'ag-grid-community'

const CommentCellRenderer = (props: ICellRendererParams) => {
  return (
    <span data-testid="CommentCellRenderer" style={{ fontFamily: 'monospace' }}>
      {props.value && (
        <pre
          style={{
            width: '100%',
            height: '100%',
            margin: 0,
            padding: 0,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {props.value}
        </pre>
      )}
    </span>
  )
}

export default CommentCellRenderer
